import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IInitialState {
    logout: boolean;
    timer: number;
}

const initialState: IInitialState = {
    logout: false,
    timer: 1,
};

const logoutSlice = createSlice({
    name: 'userLogout',
    initialState,
    reducers: {
        setLogoutTrue: (state: IInitialState, action: PayloadAction<number>) => {
            state.logout = true;
            state.timer = action.payload;
        },

        setLogoutFalse: (state: IInitialState) => {
            state.logout = false;
            state.timer = 0;
        },
    },
});

export default logoutSlice.reducer;
export const { setLogoutTrue, setLogoutFalse } = logoutSlice.actions;
